<template>
  <main class="main">
    <section>
      <h2>bookshelfサンプル</h2>
      <BookShelf />
    </section>
  </main>
</template>

<script>
import BookShelf from './BookShelf/BookShelf'

export default {
  name: 'Main',
  components: {
    BookShelf,
  },
}
</script>

<style>
.main {
  margin: 50px auto;
  width: 1200px;
}
h2 {
  font-size: 26px;
  font-weight: 500;
  color: #212e42;
  border-left: 20px double #144185;
  margin: 0 0 50px;
  padding: 0.5em 0 0.5em 1em;
}
h3 {
  /*color: #412212;*/
  font-size: 26px;
  font-weight: 700;
  text-align: center;
  padding: 23px 0 0;
  color: transparent;
  background: rgba(0, 0, 0, 1);
  text-shadow: 0 0 0.1em rgba(255, 255, 255, 1),
    0.01em 0.02em 0.02em rgba(255, 255, 255, 1);
  -webkit-background-clip: text;
}
</style>
